<app-error-message
  heading="{{ 'error.title.server' | translate | async }}"
  message="{{ message ? message : translationKey | translate | async}}"
  [hasAction]="true"
>
  <vue-basic-button color="warn" (clicked)="retry.emit()">
    {{ "button.tryAgain" | translate | async }}
  </vue-basic-button>
</app-error-message>
